import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { getEnv } from 'utils';
import { defaultTheme } from './default';
import { suiviTheme } from './suivi';

const UiThemeProvider = ({ children, ...otherProps }) => {
  const appName = getEnv('REACT_APP_NAME');

  return (
    <ThemeProvider
      theme={appName === 'suivi' ? suiviTheme : defaultTheme}
      {...otherProps}
    >
      {children}
    </ThemeProvider>
  );
};

UiThemeProvider.propTypes = {
  children: PropTypes.node,
};

export default UiThemeProvider;
